import React from "react";
import { ModalProps } from "react-rainbow-components/components/Modal";
import { uploadImageReturnUrl } from "../../../functions/storage";
import { IChat } from "../../../interfaces/chat";
import { sendChatMessage } from "../../../services/chat.service";
import { useError } from "../../../store/ErrorModal";

export default function useModalMenuChat(
  props: ModalProps & { uid: string; doctorId: string }
) {
  const fileInput = React.useRef<any>();
  const { onError } = useError();
  const [isCrateVideoRoom, setIsCreatingRoom] = React.useState<boolean>();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [linkInput, setLinkInput] = React.useState<string>("");
  const handleFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.currentTarget.files;
    let urlList: string[] = [];
    if (!fileUploaded) return;
    setIsLoading(true);
    for (const file of Array.from(fileUploaded)) {
      try {
        const res = await uploadImageReturnUrl(file, `/chats/${props.uid}/`);
        urlList.push(res);
      } catch (error) {
        setIsLoading(false);
        return onError(error as any);
      }
    }
    for (const url of urlList) {
      const newChat: IChat = {
        uid: props.uid,
        timestamp: new Date().getTime(),
        type: "image",
        doctorId: props.doctorId,
        url,
      };
      try {
        await sendChatMessage(newChat);
      } catch (error) {
        onError(error as any);
      }
    }
    setIsLoading(false);
    props.onRequestClose && props.onRequestClose();
  };
  const InputClick = () => fileInput.current.click();
  const handleSendMeetingRoom = async () => {
    if (!linkInput || linkInput === "") return;
    setIsLoading(true);
    const newChat: IChat = {
      uid: props.uid,
      timestamp: new Date().getTime(),
      type: "meeting",
      doctorId: props.doctorId,
      meetingRoomUrl: linkInput,
    };
    try {
      await sendChatMessage(newChat);
    } catch (error) {
      setIsLoading(false);
      return onError(error as any);
    }
    setIsLoading(false);
    props.onRequestClose && props.onRequestClose();
  };

  return {
    isLoading,
    InputClick,
    fileInput,
    handleFile,
    setIsCreatingRoom,
    isCrateVideoRoom,
    handleSendMeetingRoom,
    setLinkInput,
    linkInput,
  };
}
